import Tabs from '../components/tabs.svelte'
import servicePopup from '../components/service-popup.svelte'

const { $ } = window

export default {
	init() {
		let $tabs = $('#services-s3')
		if ($tabs.length) {
			new Tabs({
				target: $tabs[0],
				props: $tabs.data(),
			})
		}

		new servicePopup({
			target: document.body,
		})
	},
	finalize() {
		// JavaScript to be fired on the services page, after the init JS
	},
}
